if (!customElements.get('dt-philosophy-tabs')) {
  customElements.define(
    'dt-philosophy-tabs',
    class DtPhilosophyTabs extends HTMLElement {
      connectedCallback() {
        this.panels = Array.from(this.querySelectorAll('[data-philosophy-panel]'));
        this.jumps = Array.from(this.querySelectorAll('[data-philosophy-jump]'));

        const initialPanel = this.panels.find((panel) => !panel.hidden) || this.panels[0];
        this.panels.forEach((panel) => {
          const isActive = panel === initialPanel;
          panel.hidden = false;
          panel.classList.toggle('is-active', isActive);
          panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
          panel.inert = !isActive;
        });

        this.jumps.forEach((jump) => {
          jump.addEventListener('click', () => this.activate(jump.dataset.philosophyJump));
        });

        this.addEventListener('touchstart', this.onTouchStart, { passive: true });
        this.addEventListener('touchend', this.onTouchEnd, { passive: true });

        if (window.Shopify && Shopify.designMode) {
          document.addEventListener('shopify:block:select', this.onBlockSelect);
        }
      }

      disconnectedCallback() {
        this.removeEventListener('touchstart', this.onTouchStart);
        this.removeEventListener('touchend', this.onTouchEnd);
        if (window.Shopify && Shopify.designMode) {
          document.removeEventListener('shopify:block:select', this.onBlockSelect);
        }
      }

      onBlockSelect = (event) => {
        const panel = this.panels.find((item) => item.dataset.blockId === event.detail.blockId);
        if (panel) this.activate(panel.id);
      };

      onTouchStart = (event) => {
        if (event.touches.length !== 1 || event.target.closest('a, button, input, select, textarea')) {
          this.touchStart = null;
          return;
        }

        this.touchStart = {
          x: event.touches[0].clientX,
          y: event.touches[0].clientY,
        };
      };

      onTouchEnd = (event) => {
        if (!this.touchStart || event.changedTouches.length !== 1) return;

        const deltaX = event.changedTouches[0].clientX - this.touchStart.x;
        const deltaY = event.changedTouches[0].clientY - this.touchStart.y;
        this.touchStart = null;

        if (Math.abs(deltaX) < 56 || Math.abs(deltaX) <= Math.abs(deltaY) * 1.25) return;

        const activeIndex = this.panels.findIndex((panel) => panel.classList.contains('is-active'));
        if (activeIndex < 0) return;
        const direction = deltaX < 0 ? 1 : -1;
        const targetIndex = (activeIndex + direction + this.panels.length) % this.panels.length;
        this.activate(this.panels[targetIndex].id);
      };

      activate(panelId) {
        const activePanel = this.panels.find((panel) => panel.id === panelId);
        if (!activePanel) return;

        this.panels.forEach((panel) => {
          const isActive = panel === activePanel;
          panel.classList.toggle('is-active', isActive);
          panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
          panel.inert = !isActive;
        });
      }
    }
  );
}
